import { render, staticRenderFns } from "./ItemsShowPage.vue?vue&type=template&id=02ba319a&"
import script from "./ItemsShowPage.vue?vue&type=script&lang=js&"
export * from "./ItemsShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports